// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig } from "firebase/remote-config";
import { fetchAndActivate, getValue } from "firebase/remote-config";

const firebaseConfig = {
  apiKey: "AIzaSyDJChtfjUB5TSJ4Wks4h98aWNGOAd0JIhE",
  authDomain: "ohyafinance.firebaseapp.com",
  projectId: "ohyafinance",
  storageBucket: "ohyafinance.appspot.com",
  messagingSenderId: "305262467991",
  appId: "1:305262467991:web:022316bf8df2e8840c42d2",
  measurementId: "G-4ZCKVGGNCW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig, "ohyaFinanceFirebase");

const analytics = getAnalytics(app);
const remoteConfig = getRemoteConfig(app);

remoteConfig.settings.minimumFetchIntervalMillis = 20000;

fetchAndActivate(remoteConfig);

// const getNoticeContent = async () => {
//   try {
//     await fetchAndActivate(remoteConfig);
//     const noticeValue = getValue(remoteConfig, "Notice_content");
//     return noticeValue;
//   } catch (error) {
//     console.error("Failed to fetch and activate remote config:", error);
//     return null;
//   }
// };

// const getNoticeTitle = async () => {
//   try {
//     await fetchAndActivate(remoteConfig);
//     const noticeValue = getValue(remoteConfig, "Notice_title");
//     return noticeValue;
//   } catch (error) {
//     console.error("Failed to fetch and activate remote config:", error);
//     return null;
//   }
// };

const getNotice = async () => {
  try {
    await fetchAndActivate(remoteConfig);
    const noticeDatas = (getValue(
      remoteConfig,
      process.env.REACT_APP_FIREBASE_NOTICE || "Notice"
    ) as unknown) as {
      _value: string;
    };
    const formatNoticeData = JSON.parse(noticeDatas._value);

    return formatNoticeData;
  } catch (error) {
    console.log("Fail to fetch and activate remote config", error);
    return null;
  }
};

const getAntiFraudNotice = async () => {
  try {
    await fetchAndActivate(remoteConfig);
    const antiFraudNoticeDatas = (getValue(
      remoteConfig,
      process.env.REACT_APP_FIREBASE_ANTI_FRAUD_NOTICE || "Anti_fraud_notice"
    ) as unknown) as {
      _value: string;
    };
    const formatAntiFraudNoticeDatas = JSON.parse(antiFraudNoticeDatas._value);

    return formatAntiFraudNoticeDatas;
  } catch (error) {
    console.log("Fail to fetch and activate remote config", error);
    return null;
  }
};

const getNewsData = async () => {
  try {
    await fetchAndActivate(remoteConfig);
    const newsData = (getValue(
      remoteConfig,
      process.env.REACT_APP_FIREBASE_NEWS || "News"
    ) as unknown) as {
      _value: string;
    };
    const formatNewsData = JSON.parse(newsData._value);

    return formatNewsData;
  } catch (error) {
    console.error("Failed to fetch and activate remote config:", error);
    return [];
  }
};

const getFestiveNoticeData = async () => {
  try {
    await fetchAndActivate(remoteConfig);
    const data = (getValue(
      remoteConfig,
      process.env.REACT_APP_FIREBASE_FESTIVE_NOTICE || "Festive_notice"
    ) as unknown) as {
      _value: string;
    };
    const formatData = JSON.parse(data._value);
    return formatData;
  } catch (error) {
    console.error("Failed to fetch and activate remote config:", error);
    return [];
  }
};

export {
  app,
  analytics,
  getNotice,
  getAntiFraudNotice,
  getNewsData,
  getFestiveNoticeData,
};
